import type { Theme } from '../lib/personas';

interface CardBackDesignProps {
  theme: Theme;
  selected?: boolean;
  className?: string;
}

const IMAGE2_BACKS: Record<Theme, string> = {
  morandi: '/image2/card-back-morandi.svg',
  mystic: '/image2/card-back-mystic.svg',
  minimal: '/image2/card-back-minimal.svg',
};

export default function CardBackDesign({
  theme,
  selected = false,
  className = '',
}: CardBackDesignProps) {
  const selectedRing =
    theme === 'mystic'
      ? 'rgba(229,200,116,0.9)'
      : theme === 'morandi'
      ? 'rgba(184,122,111,0.85)'
      : 'rgba(138,42,42,0.78)';

  const selectedGlow =
    theme === 'mystic'
      ? '0 0 24px rgba(201,162,74,0.32)'
      : theme === 'morandi'
      ? '0 0 22px rgba(184,122,111,0.26)'
      : '0 10px 22px rgba(10,10,10,0.1)';

  return (
    <div
      className={[
        'absolute inset-0 overflow-hidden',
        selected ? 'tarot-card-aura' : '',
        className,
      ].join(' ')}
      style={{
        borderRadius: 'var(--radius-card)',
        border: selected ? `1px solid ${selectedRing}` : '1px solid var(--color-border)',
        boxShadow: selected ? selectedGlow : 'none',
        background:
          theme === 'mystic'
            ? 'linear-gradient(145deg, #171225, #07060d)'
            : theme === 'morandi'
            ? 'linear-gradient(145deg, #ead8c6, #c18478)'
            : 'linear-gradient(180deg, #fffdfa, #f2eee6)',
      }}
    >
      <img
        src={IMAGE2_BACKS[theme]}
        alt=""
        className="h-full w-full object-cover contrast-[1.08] saturate-[1.08]"
        draggable={false}
      />
      <span
        className="pointer-events-none absolute inset-[12%]"
        style={{
          border: `1px solid ${
            theme === 'mystic'
              ? 'rgba(201,162,74,0.55)'
              : theme === 'morandi'
              ? 'rgba(255,248,239,0.72)'
              : 'rgba(10,10,10,0.2)'
          }`,
          borderRadius: 'calc(var(--radius-card) * 0.8)',
        }}
      />
      <span
        className="pointer-events-none absolute left-1/2 top-1/2 h-[34%] w-[34%] -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{
          border: `1px solid ${
            theme === 'mystic'
              ? 'rgba(201,162,74,0.6)'
              : theme === 'morandi'
              ? 'rgba(255,248,239,0.8)'
              : 'rgba(138,42,42,0.72)'
          }`,
          boxShadow:
            theme === 'mystic'
              ? '0 0 18px rgba(201,162,74,0.22)'
              : theme === 'morandi'
              ? '0 0 14px rgba(255,248,239,0.36)'
              : 'none',
        }}
      />
      <span className="tarot-card-sheen" />
    </div>
  );
}
